import axios from 'axios';
import { clearAuthData } from './auth';

const notificationClient = axios.create({
    baseURL: import.meta.env.VITE_NOTIFICATION_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

notificationClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

notificationClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default notificationClient;
